/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import App from 'apmui/App';
import EventTags from 'apmui/EventTags';
import { DialogType } from 'apmui/components/dialog/Model';
import { IHeaderModel } from 'apmui/master/Model';

const app = App.get();

class MaxTimeoutTag extends React.Component<{ title?: string }> {
    /**
     * This component will be updated from sesstimeout.js.
     * Disable normal updates to avoid losing timeout values.
     */
    shouldComponentUpdate() {
        return false;
    }
    render() {
        return <span className="apmui-header--timeout" id="maxTimeoutTag" title={this.props.title} />;
    }
}

class HeaderControls extends React.Component<IHeaderModel> {
    onLogoutClick() {
        app.dispatch(EventTags.LOGOUT);
    }
    onSettingsClick() {
        app.showModal(DialogType.VDI_SETTINGS).catch(() => true);
    }
    render() {
        return (
            <div className="apmui-header--controls">
                <MaxTimeoutTag title={this.props.maxTimeoutTitle} />
                <div className="apmui-header--buttons">
                    {this.props.showSettings && (
                        <button
                            aria-label={this.props.settingsLabel}
                            className="apmui-button-settings"
                            id="webtop_settings"
                            onClick={this.onSettingsClick}
                            title={this.props.settingsLabel}>
                            <img alt={this.props.settingsLabel} src={this.props.settingsIcon} />
                        </button>
                    )}
                    <button className="apmui-button apmui-button-logout" id="disconnect" onClick={this.onLogoutClick}>
                        {this.props.disconnectCaption}
                    </button>
                </div>
            </div>
        );
    }
}

export default HeaderControls;
